import React from 'react';

export default props => (
	<g transform="matrix(0.0625,0,0,0.0625,0,0.1875)">
		<g>
			<path d="M 467,61 H 45 C 20.218,61 0,81.196 0,106 v 300 c 0,24.72 20.128,45 45,45 h 422 c 24.72,0 45,-20.128 45,-45 V 106 C 512,81.28 491.872,61 467,61 Z M 460.786,91 256.954,294.833 51.359,91 Z M 30,399.788 V 112.069 l 144.479,143.24 z M 51.213,421 195.783,276.43 246.44,326.652 c 5.864,5.814 15.327,5.795 21.167,-0.046 L 317,277.213 460.787,421 Z M 482,399.787 338.213,256 482,112.212 Z" />
		</g>
	</g>
);
